export const ADD_MEASURES = 'ADD_MEASURES'
export const ADD_MEASURE = 'ADD_MEASURE'
